import useListPageSearchParams from '@/hooks/useListPageSearchParams';
import CompanyDetail from '../Company/components/Detail';
import AnalysisList from '../Company/components/AnalysisTable';

const AnalysisListPage = () => {
  const { detailId: companyId, listParams, updateListParams, buildDetailUrl, clearDetailParam } = useListPageSearchParams({
    path: '/analysis',
    createParams: ({ pageIndex, pageSize, search }) => ({
      pageIndex,
      pageSize,
      companyId: '',
      search,
    }),
  });

  return (
    <>
      {companyId && (
        <div>
          <CompanyDetail
            onReturn={() => {
              clearDetailParam();
            }}
          />
        </div>
      )}
      <div
        style={{
          display: companyId ? 'none' : 'block',
        }}
      >
        <AnalysisList
          from="all"
          externalParams={listParams}
          onParamsChange={updateListParams}
          buildCompanyDetailUrl={buildDetailUrl}
        />
      </div>
    </>
  );
};
export default AnalysisListPage;
